export var FormId;
(function (FormId) {
    FormId["Login"] = "login-form";
    FormId["Register"] = "registration-form";
    FormId["Start"] = "registration-start-form";
    FormId["IdpUpdateProfile"] = "idp-update-profile-form";
    FormId["IdpLinkConfirm"] = "idp-link-confirm-form";
    FormId["EmailCodeForm"] = "email-code-form";
    FormId["DeleteAccountConfirm"] = "delete-account-confirm-form";
    FormId["UpdateEmailForm"] = "update-email-form";
    FormId["LinkDeviceAccountGrant"] = "link-device-account-grant-form";
    FormId["LinkDeviceAccountCancel"] = "link-device-account-cancel-form";
    FormId["LinkDeviceAccountChangeAccount"] = "link-device-account-change-account-form";
    FormId["DeviceLogin"] = "device-login-form";
    FormId["LoginConfirmation"] = "login-confirmation-form";
    FormId["LoginOauthGrant"] = "login-oauth-grant-form";
    FormId["LoginOauthGrantCancel"] = "login-oauth-grant-cancel-form";
})(FormId || (FormId = {}));
export var ViewId;
(function (ViewId) {
    ViewId["Login"] = "login";
    ViewId["RegistrationStart"] = "registration-start";
    ViewId["RegistrationContinue"] = "registration-continue";
    ViewId["OneTimePassword"] = "one-time-password";
    ViewId["IdpRegistrationUpdateProfile"] = "idp-registration-update-profile";
    ViewId["IdpRegistrationConfirmLinking"] = "idp-registration-confirm-linking";
    ViewId["RegistrationSuccess"] = "registration-success";
    ViewId["LoginConfirmation"] = "login-confirmation";
    ViewId["DeviceLoginCode"] = "device-login-code";
    ViewId["DeviceLoginConfirmation"] = "device-login-confirmation";
    ViewId["DeviceLoginSuccess"] = "device-login-success";
    ViewId["DeviceLoginDenied"] = "device-login-denied";
    ViewId["Info"] = "info";
    ViewId["Error"] = "error";
    ViewId["DeleteAccountConfirm"] = "delete-account-confirm";
    ViewId["UpdateEmail"] = "update-email";
    ViewId["LoginOauthGrant"] = "login-oauth-grant";
})(ViewId || (ViewId = {}));
